import { render } from "./DebugTest.vue?vue&type=template&id=58a15bd2&scoped=true"
import script from "./DebugTest.vue?vue&type=script&lang=js"
export * from "./DebugTest.vue?vue&type=script&lang=js"

import "./DebugTest.vue?vue&type=style&index=0&id=58a15bd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a15bd2"]])

export default __exports__